<ptl-v3-filter-shell [title]="'translations.reviews.filter.group' | transloco" (applied)="applyFilter()" (deleted)="deleteFilter()">
  <ng-container ngProjectAs="[shell-controls]">
    <ptl-select
      class="v3-group-filter__select"
      [options]="isOptions"
      [ngModel]="groupIs"
      (selectionChange)="onGroupIsChange($event)"
    ></ptl-select>
    @if (groupIs) {
      <ptl-select
        class="v3-group-filter__select"
        [options]="operatorOptions"
        [ngModel]="logicalOperator"
        (selectionChange)="onLogicalOperatorSelection($event)"
      ></ptl-select>
    }
  </ng-container>

  <div class="v3-group-filter__search">
    <ptl-sg-input
      [withIcon]="true"
      [icon]="LucideSearch"
      [placeholder]="'translations.reviews.label.searchForGroups' | transloco"
      (inputChange)="onSearchInputChange($event)"
    ></ptl-sg-input>
    @if (!loadingGroups && foundGroups.length) {
      <div class="v3-group-filter__results" role="listbox">
        @for (group of foundGroups; track group._id) {
          <button
            type="button"
            class="v3-group-filter__result"
            role="option"
            [attr.aria-selected]="isGroupSelected(group)"
            [class.is-selected]="isGroupSelected(group)"
            (click)="onGroupSelected(group)"
          >
            {{ group.title }}
          </button>
        }
      </div>
    }
  </div>

  @if (activeGroups.length) {
    <div class="v3-group-filter__badges">
      @for (group of activeGroups; track group._id; let i = $index) {
        <ptl-base-badge [text]="group.title" [iconSuffix]="LucideX" (iconClick)="onGroupRemoved(i)"></ptl-base-badge>
      }
    </div>
  }
</ptl-v3-filter-shell>
